<div class="kpi-config-container" >
    <div class="kpi-selection-container">
        <div class="right-section">
            <div class="right-section-top-container">
                <span class="right-section-title">
                    <div class="title">
                        Impacted KPIs
                    </div>
                    <div class="note">
                        Note: start adding KPIs through "Select KPIs" button
                    </div>
                </span>
                <span class="add-kpi-button">
                    <button (click)="onSelectKpiClicked()">
                        <div class="add-kpi-button-text">
                            SELECT KPIS
                            <img class="add-kpi-button-icon addIcon" src=""/>
                               </div>
                    </button>
                </span>
            </div>

            <div class="kpi-list-container">
                <div class="count-paginator-container">
                    <div class="kpi-count" [ngClass]="{'no-kpis': count === 0}">
                      {{count > 1 ? "IMPACTED KPIS" : "IMPACTED KPI"}} ({{count}})
                    </div>
                    <div class ="paginator" [hidden]="count === 0">
                        <mat-paginator #scheduledOrdersPaginator [hidePageSize]="true" [pageSizeOptions]="[6]" showFirstLastButtons></mat-paginator>
                    </div>
                </div>
                <div class="line-divider">
                    <div class="circle"></div>
                    <div class="line"></div>
                    <div class="circle"></div>
                </div> 
                <div class="table-container">
                    <div class="no-kpi-message" [hidden]="count > 0">
                        <img class="icon infoIcon" src=""/>
                        <div class="message">NO KPIS HAVE BEEN ADDED</div>
                        <div class="note">Click “Select KPIs” to Assign KPIs</div>
                    </div>
                    <div class="selected-kpis-container" [hidden]="count === 0">
                        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z0">
                            <ng-container matColumnDef="name">
                              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by actionTitle">
                                Name
                              </th>
                              <td mat-cell *matCellDef="let kpi">
                                <span appTooltip="{{kpi.name}}" [tooltipPosition]="'top'"
                                [tooltipShow]="(kpi.name.length) > 24">
                                    <div class="kpi-options-text">
                                        {{kpi.name | shorten: 24}}
                                    </div>
                                </span>
                              </td>
                            </ng-container>
                            <ng-container matColumnDef="role">
                              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by dateCreated">
                                Role
                              </th>
                              <td mat-cell *matCellDef="let kpi">
                                <span appTooltip="{{kpi.role.roleName}}" [tooltipPosition]="'top'"
                                [tooltipShow]="(kpi.role.roleName.length) > 24">
                                    <div class="kpi-options-text">
                                        {{kpi.role.roleName | shorten: 24}}
                                    </div>
                                </span>
                              </td>
                            </ng-container>
                            <ng-container matColumnDef="department">
                              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by actionBy">
                                Department
                              </th>
                              <td mat-cell *matCellDef="let kpi">
                                <span appTooltip="{{kpi.department.departmentName}}" [tooltipPosition]="'top'"
                                [tooltipShow]="(kpi.department.departmentName.length) > 24">
                                    <div class="kpi-options-text">
                                        {{kpi.department.departmentName | shorten: 24}}
                                    </div>
                                </span>
                              </td>
                            </ng-container>
                            <ng-container matColumnDef="ahLevel">
                              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by status">
                                AH Level
                              </th>
                              <td mat-cell *matCellDef="let kpi">
                                <span appTooltip="{{kpi.assetHierarchyLevel}}" [tooltipPosition]="'top'"
                                [tooltipShow]="(kpi.assetHierarchyLevel.length) > 24">
                                    <div class="kpi-options-text">
                                        {{kpi.assetHierarchyLevel | shorten: 24}}
                                    </div>
                                </span>
                              </td>
                            </ng-container>
                            <ng-container matColumnDef="frequency">
                              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by assignedTo">
                                Frequency
                              </th>
                              <td mat-cell *matCellDef="let kpi">
                                <span appTooltip="{{kpi.frequency}}" [tooltipPosition]="'top'"
                                [tooltipShow]="(kpi.frequency?.length) > 24">
                                    <div class="kpi-options-text">
                                        {{kpi.frequency | shorten: 24}}
                                    </div>
                                </span>
                              </td>
                            </ng-container>
                            <ng-container matColumnDef="buttons">
                              <th mat-header-cell *matHeaderCellDef></th>
                              <td mat-cell *matCellDef="let kpi">
                                <div class="table-icons">
                                    <button (click)="deleteSelectedKpi(kpi)">
                                        <img class="add-kpi-button-icon deleteIcon" src=""/>
                                        </button>
                                </div> 
                              </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                          </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


